import { useNavigate } from 'react-router-dom';

import DontsovaImg from '1_shared/assets/images/experts/dontsova@2x.png';
import DydychkinaImg from '1_shared/assets/images/experts/dydychkina@2x.png';
import GladkovskayaImg from '1_shared/assets/images/experts/gladkovskaya@2x.png';
import KuznetsovaImg from '1_shared/assets/images/experts/kuznetsova@2x.png';
import PopovaImg from '1_shared/assets/images/experts/popova@2x.png';
import ShtukaturevaImg from '1_shared/assets/images/experts/shtukatureva@2x.png';
import SipyaginImg from '1_shared/assets/images/experts/sipyagin@2x.png';
import VaismanImg from '1_shared/assets/images/experts/vaisman@2x.png';
import MipLogoImg from '1_shared/assets/images/mip-logo@2x.png';
import { ReactComponent as ExpertsAll } from '1_shared/assets/pictures/stack/icons/experts-all.svg';

import { RoutePath } from '../../../config/routes';

import 'app/styles/global/global.scss';
import './specialists.scss';
import styles from './Specialists.module.scss';
import PriceComponent from './PriceComponent/PriceComponent';
import cn from 'classnames';
import { specInfo } from '../model/specialistsInfo';
import { FindSpecialistBtn } from '../../index';
import { useAuthContext } from '../../../../app/module/lib/hooks/useAuthContext';

const Specialists = ({ withPrices = false }: { withPrices?: boolean }) => {
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const handleClick = (specIdentification: string) => {
    navigate(`/specialists/specialist/${specIdentification}`);
  };

  const onCircleButtonClick = () => {
    // @ts-ignore
    ym(97788822, 'reachGoal', 'circle', {
      isAuthorize: !!user,
      userId: user?.userId ?? null,
    });

    if (!user?.userId) {
      navigate(RoutePath.REACT_ANKETA, { state: { actionTab: '2' } });
    } else {
      navigate(RoutePath.SPECIALISTS, {
        state: { anchor: '#specialists' },
      });
    }
  };

  return (
    <section className="specialists" id="specialists">
      <div className="container specialists__container">
        <div className="specialists__inner">
          <div className="specialists__desc specialists__desc--top">
            <h2 className="specialists__title section-title">
              Более 500 <br /> специалистов
            </h2>
            <p className="specialists__subtitle">
              Отобранные экспертным сообществом профессионалы, подтвердившие
              свой опыт большим количеством успешных кейсов
            </p>
          </div>
          <div className="specialists__list-wrapper">
            <ul className="specialists__list">
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.popova.specId)}
              >
                <div>
                  <img src={PopovaImg} alt="Татьяна Попова" />
                  <h3>Татьяна Попова </h3>
                  <p>
                    Преподаватель МИП • КПН, экзистенциально-гуманистическая
                    терапия, арт-терапия, когнитивно-поведенческая психотерапия;
                    Лауреат национального конкурса «Золотая психея»
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.popova.price}
                    discountedPrice={specInfo.popova.discountedPrice}
                  />
                )}
              </li>
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.shtukatureva.specId)}
              >
                <div>
                  <img src={ShtukaturevaImg} alt="Светлана Штукарева" />
                  <h3>Светлана Штукарева</h3>
                  <p>
                    Преподаватель МИП • Руководитель Высшей Школы Логотерапии.
                    Победитель национального конкурса «Золотая Психея»
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.shtukatureva.price}
                    discountedPrice={specInfo.shtukatureva.discountedPrice}
                  />
                )}
              </li>
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.gladkovskaya.specId)}
              >
                <div>
                  <img src={GladkovskayaImg} alt="Елена Гладковская" />
                  <h3>Елена Гладковская</h3>
                  <p>
                    Преподаватель МИП • Экзистенциально-гуманистический
                    терапевт, логотерапевт, психолог-консультант, клинический
                    психолог
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.gladkovskaya.price}
                    discountedPrice={specInfo.gladkovskaya.discountedPrice}
                  />
                )}
              </li>
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.dydychkina.specId)}
              >
                <div>
                  <img src={DydychkinaImg} alt="Ольга Дыдычкина" />
                  <h3>Ольга Дыдычкина</h3>
                  <p>
                    Преподаватель МИП • Психолог-консультант, арт-терапевт,
                    магистр управления, консультативный член Профессиональной
                    Психотерапевтической Лиги
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.dydychkina.price}
                    discountedPrice={specInfo.dydychkina.discountedPrice}
                  />
                )}
              </li>
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.kuznetsova.specId)}
              >
                <div>
                  <img src={KuznetsovaImg} alt="Валерия Кузнецова" />
                  <h3>Валерия Кузнецова</h3>
                  <p>
                    Преподаватель МИП • Кандидат медицинских наук, научный
                    сотрудник Медико-Генетического Научного Центра, практикующий
                    коуч, арт-терапевт, старший научный сотрудник ЦНИИС
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.kuznetsova.price}
                    discountedPrice={specInfo.kuznetsova.discountedPrice}
                  />
                )}
              </li>
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.sipyagin.specId)}
              >
                <div>
                  <img src={SipyaginImg} alt="Дмитрий Сипягин" />
                  <h3>Дмитрий Сипягин</h3>
                  <p>
                    психоаналитик, психолог-консультант, Кандидат
                    психологических наук, Член международной психологической
                    ассоциации
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.sipyagin.price}
                    discountedPrice={specInfo.sipyagin.discountedPrice}
                  />
                )}
              </li>
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.vaisman.specId)}
              >
                <div>
                  <img src={VaismanImg} alt="Ирина Вайсман" />
                  <h3>Ирина Вайсман</h3>
                  <p>
                    Психоналитический психотерапевт, член Московской
                    психоаналитической ассоциации, Член Европейской ассоциации
                    развития психоанализа и психотерапии
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.vaisman.price}
                    discountedPrice={specInfo.vaisman.discountedPrice}
                  />
                )}
              </li>
              <li
                className={cn(styles.specialistsItem, styles.specBlock)}
                onClick={() => handleClick(specInfo.dontsova.specId)}
              >
                <div>
                  <img src={DontsovaImg} alt="Маргарита Донцова" />
                  <h3>Маргарита Донцова</h3>
                  <p>
                    Преподаватель МИП • Кандидат психологических наук,
                    когнитивно-поведенческая терапия, гештальт терапия,
                    арт-терапия
                  </p>
                </div>
                {withPrices && (
                  <PriceComponent
                    price={specInfo.dontsova.price}
                    discountedPrice={specInfo.dontsova.discountedPrice}
                  />
                )}
              </li>
              <li className="specialists__item">
                <button
                  className="specBtn"
                  type="button"
                  onClick={onCircleButtonClick}
                  aria-label="Все специалисты"
                >
                  <ExpertsAll width={134} height={134} />
                </button>
              </li>
            </ul>
          </div>
          <div className="specialists__desc specialists__desc--bottom">
            <ul className="specialists__benefits">
              <li className="specialists__benefits-item specialists__benefits-item--exp">
                Опыт от&nbsp;5&nbsp;лет
              </li>
              <li className="specialists__benefits-item specialists__benefits-item--edu">
                Только высшее образование
              </li>
              <li className="specialists__benefits-item specialists__benefits-item--ru">
                Русскоговорящие
              </li>
            </ul>
            <FindSpecialistBtn
              className="specialists__btn btn btn--violet"
              stateAnchor="#specialists"
              goalTag="150specs"
              label="показать всех специалистов"
            />
            <div className="specialists__project">
              <h4 className="specialists__project-title">
                Проект Московского института психоанализа
              </h4>
              <img
                className="specialists__project-image"
                src={MipLogoImg}
                alt="Проект Московского института психоанализа"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specialists;
